import { IVillageSuggest } from '../../types/village';
import { IRegion } from '../../components/cian/location_switcher/util';
import { IBuilderSuggest } from '../../types/builder';
import { IGeoCodeCachedItem, ILocationType, IRegionByDomain, ISearchCatalogItem } from '../../types/geo';
import { Action, EGeoActions } from './actions';

export interface ICity extends IRegion {
  regionId?: number | null;
  parentId?: number | null;
  fullName: string;
  shadowId?: number;
}

export interface IGeo {
  autocompleteSuggests: ISearchCatalogItem[];
  cities: ICity[];
  currentRegion?: IRegionByDomain;
  geoCached: IGeoCodeCachedItem[];
  geoPopupFetching: boolean;
  isAutocompleteLoading: boolean;
  isGeoLoading: boolean;
  selectedRegion?: ICity;
  selectedCity?: ICity;
  regions: IRegion[];
  villageSuggestions?: IVillageSuggest[];
  builderSuggestions?: IBuilderSuggest[];
  locationInfo: ILocationType | undefined;
}

export function geoReducer(state: IGeo, action: Action): IGeo {
  switch (action.type) {
    case EGeoActions.GeoCachedFetched:
      return { ...state, geoCached: action.payload };
    case EGeoActions.GeoLoadingStarted: {
      return { ...state, isGeoLoading: true };
    }
    case EGeoActions.GeoCachedError:
    case EGeoActions.GeocodedForSearchFetched:
    case EGeoActions.GeocodedForSearchError: {
      return { ...state, isGeoLoading: false };
    }
    case EGeoActions.RegionsFetched:
      return { ...state, regions: action.payload };
    case EGeoActions.RegionCitiesFetchStarted:
      return { ...state, cities: [], geoPopupFetching: true };
    case EGeoActions.RegionCitiesFetched:
      return { ...state, cities: action.payload, geoPopupFetching: false };
    case EGeoActions.RegionCitiesFetchError:
      return { ...state, geoPopupFetching: false };
    case EGeoActions.GeoUpdateCity:
      return { ...state, selectedCity: action.payload.region, selectedRegion: action.payload.city };
    case EGeoActions.GeoUpdateRegion:
      return {
        ...state,
        selectedCity: action.payload.parentId ? undefined : action.payload,
        selectedRegion: action.payload,
      };
    case EGeoActions.RegionsCitiesFetchStarted:
      return { ...state, isAutocompleteLoading: true };
    case EGeoActions.RegionsCitiesFetched:
      return { ...state, autocompleteSuggests: action.payload, isAutocompleteLoading: false };
    case EGeoActions.RegionsCitiesFetchError:
      return { ...state, isAutocompleteLoading: false };
    case 'GetRegionByDomainFetched':
      return {
        ...state,
        selectedRegion: action.payload,
      };
    case EGeoActions.RegionFetched:
      return {
        ...state,
        currentRegion: action.payload,
      };
    case EGeoActions.VillageSuggestionsFetched:
      return {
        ...state,
        villageSuggestions: action.payload,
      };
    case EGeoActions.VillageSuggestionsFetchError:
      return {
        ...state,
        villageSuggestions: [],
      };
    case EGeoActions.BuilderSuggestionsFetched:
      return {
        ...state,
        builderSuggestions: action.payload,
      };
    case EGeoActions.BuilderSuggestionsFetchError:
      return {
        ...state,
        builderSuggestions: [],
      };
    case EGeoActions.LocationInfoFetched:
      return {
        ...state,
        locationInfo: action.payload,
      };
    case EGeoActions.LocationInfoFetchError:
      return {
        ...state,
        locationInfo: undefined,
      };
    default:
      return state || {};
  }
}

export const DEFAULT_GEO_STATE = {
  autocompleteSuggests: [],
  cities: [],
  geoCached: [],
  geoPopupFetching: false,
  isAutocompleteLoading: false,
  isGeoLoading: false,
  regions: [],
};
